import { render, staticRenderFns } from "./lrCode.vue?vue&type=template&id=52c9d980"
import script from "./lrCode.vue?vue&type=script&lang=js"
export * from "./lrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports